import React, { FC } from 'react'

import { Link } from 'shared/components/link/Link'

import { IUploadedFilesProps } from './models'

import styles from './UploadedFiles.module.scss'

export const UploadedFiles: FC<IUploadedFilesProps> = ({ files, onDelete, isDisabled }) => {
  return (
    <div>
      <div className={styles.uploadedFilesTitle}>Uploaded files</div>
      <div className={styles.uploadedFilesContainer}>
        {files.map(({ entryId, fileName, link = '' }) => (
          <Link
            isFile
            key={fileName + entryId}
            link={link}
            text={fileName}
            isDisabled={isDisabled}
            onDelete={() => {
              onDelete(entryId)
            }}
          />
        ))}
      </div>
    </div>
  )
}
